module.exports = __webpack_public_path__ + "static/media/profile_update_confirmation.090463a9.svg";